import React from 'react'
import useMediaQuery from '../../../shared/utils/useMediaQuery'
import flechas from '../../../assets/images/modals/flechas-game-3.svg'
import person from '../../../assets/images/modals/person-game-3.png'
import txtimg from '../../../assets/images/modals/txt-game-3.png'


import './modalFlujo.scss'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const ModalFlujo = ({ handleCTA }) => {
  const isMobile = useMediaQuery()

  return (
    <div className='f-flujo-container'>
      <div className='f-flujo-container__wrapper'>
        <div className='f-flujo-container__content'>
          <div className='f-flujo-container__content-img'>
            <h2>Nivel 3</h2>

            <img src={txtimg} className='f-flujo-container__content-img-txt' />
            <img src={person} className='f-flujo-container__content-img-person' />

          </div>
          <div className='f-flujo-container__content-txt'>
            <p>
              <b> La pubertad </b>es cambios y más cambios; físicos, emocionales y hormonales. Hay un rango de años para
              que
              empiece esta etapa tan maravillosa para ti.
            </p>

            <p>
              En este juego, <b>mové a Pubertad para atrapar todos los personajes</b> que representan esta fase de tu
              vida,
              tanto para hombres como para mujeres.
            </p>

            <p>
              <b>¡Sé la mejor y divertite!</b>
            </p>


            <div className='f-flujo-container__content-txt-instruction'>
              {isMobile ? (
                <p>Usá las flechas de tu pantalla para moverte hacia los lados.</p>
              ) : (
                <p>Usá las flechas de tu teclado para moverte hacia los lados.</p>
              )}
              <img src={flechas} />
            </div>


            <div className='f-flujo-container__content-txt-img'>
              <img src={txtimg} className='f-flujo-container__content-img-txt--mobile' />

            </div>
            <div className='f-flujo-container__content-txt-btn'>
              <button onClick={() => {
                pushEventDataLayer('Personajes :: Juego', 'Nivel 3', 'QUIERO JUGAR')
                handleCTA()
              }}>
                QUIERO JUGAR
              </button>
            </div>
            <div className='f-flujo-container__content-txt-img'>
              <img src={person} className='f-flujo-container__content-img-person--mobile' />

            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalFlujo
